/* eslint-disable react/jsx-no-useless-fragment */

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
// eslint-disable-next-line import/no-cycle
import { PTMTooltip } from "./index";

/**
 * PTMIcon: FontAwesome Icon with integrated tooltip that can be activated via prop "popover"
 */

export default function PTMIcon(props) {
    const {
        icon,
        popover,
        style,
        iconStyle,
        classes,
        fixedWidth,
        onClick,
    } = props;

    return (

        <>
            {
                popover ? (
                    <PTMTooltip
                        title={popover}
                        style={{ lineHeight: "initial", ...style }}
                        onClick={onClick}
                    >
                        <FontAwesomeIcon style={iconStyle} icon={icon} className={classes} fixedWidth={fixedWidth} />
                    </PTMTooltip>
                )
                    : <FontAwesomeIcon style={iconStyle} icon={icon} className={classes} fixedWidth={fixedWidth} />

            }
        </>

    );
}

PTMIcon.propTypes = {
    icon: PropTypes.string,
    popover: PropTypes.string,
    style: PropTypes.shape({}),
    iconStyle: PropTypes.shape({}),
};

PTMIcon.defaultProps = {
    icon: "",
    popover: "",
    style: {},
    iconStyle: {},
};
